export enum OrganizationThemeEnum {
	DEFAULT = 'parkchirp',
	DEFAULT_DARK = 'parkchirp-dark',
	ABM = 'abm',
	UNIVERSAL = 'universal',
	PCI = 'pci',
	LEGACY = 'legacy',
	PRIME = 'prime',
	ATLANTIC = 'atlantic',
	NATIONAL_PARKING = 'national parking',
	PEAK_PARKING = 'peak parking',
	PARKWELL = 'parkwell',
	PARKING_NW = 'parking nw',
	IPM = 'ipm',
	ACE = 'ace',
	LITTLE_MAN_PARKING = 'little man parking',
	PROPARK = 'propark',
	PIVOT_PARKING = 'pivot parking',
	ONE_PARKING = 'one parking',
	PARKING_SYSTEMS_OF_AMERICA = 'parking systems of america',
	CITRIN = 'citrin',
	PREFERRED_PARKING = 'preferred parking',
	OVG = 'oak view group',
	ICON = 'icon',
	PLATINUM = 'platinum',
	PARKX = 'parkx',
	PARKING_COMPANY_OF_AMERICA = 'parking company of america',
	PARKING_ADVANTAGE = 'parking advantage',
	MAKE_PARKING_PAYMENT = 'make parking payment',
	LAS_VEGAS_PARKING = 'las vegas parking',
	CITY_PARKING = 'cityparking inc.',
	PCAM = 'pcam',
	TRUPARK = 'trupark',
	SIGNATURE_PARKING = 'signature parking',
	REZY_PARK = 'rezy park',
	UNITED_PARKING_SYSTEMS = 'united parking systems',
}
